import React from "react";
import Functions from "../src/functions";
import Manager from "../src/manager";
import ReactDOM from "react-dom";
import ErrorPage from "../themes/cosmote/templates/errorPage";

const BaseURL = "/api";

const CustomFunctions = {
	restAPI: function (url) {
		return BaseURL.concat(url);
		// return url;
	},

	logout: function () {
		sessionStorage.clear();
		window.location.replace("/");
	},

	getUserType: function () {
		if (sessionStorage)
			return JSON.parse(sessionStorage.landPageData).contractInfoCarrier
				.customerSegment;
		else return null;
	},

	createURL: function (url) {
		let hostname = window.location.hostname;
		let port = window.location.port == 80 ? "" : ":" + window.location.port;

		return window.location.protocol + "//" + hostname + port + url;
	},
	testFunction: function () {
		alert("Hello there");
	},
	restCallback: function (data, status, response, url) {
		let UserType = Functions["custom"]["getUserType"]();
		let residential = JSON.parse(sessionStorage.getItem("residential"));
		if (
			(response.data.messageCode &&
				response.data.messageCode === "generalError") ||
			status !== 200
		) {
			if (response.config.url === "/page/submitService") return;
			window["modal"].setState({
				show: true,
				footer: [],
				body:
					residential.indexOf(UserType) !== -1 ? (
						<div className="thank-hold errorPageDisplay">
							<div
								className="thank content"
								id="warningsErrorOccured"
								style={{ display: "block" }}>
								<div className="deactivation-icon-background"></div>
								<div className="deactivation-icon"></div>
								<h2 className="errorheader">
									Σας ενημερώνουμε ότι η υπηρεσία <br /> αυτή τη στιγμή δεν
									είναι διαθέσιμη.
								</h2>{" "}
								<h2 className="errorheader2">
									Για περισσότερες πληροφορίες καλέστε <br /> την Εξυπηρέτηση
									Πελατών - 13888
								</h2>
								<a
									href="/"
									className="cancel">
									Επιστροφή &gt;
								</a>
							</div>
						</div>
					) : (
						<div
							className="thank-hold"
							style={{ display: "block" }}>
							<div
								className="thank"
								style={{ display: "block" }}>
								<h2 className="errorheader">
									Σας ενημερώνουμε ότι η υπηρεσία <br /> αυτή τη στιγμή δεν
									είναι διαθέσιμη.
								</h2>{" "}
								<h2 className="errorheader2">
									Για περισσότερες πληροφορίες καλέστε <br />
									την Εξυπηρέτηση Πελατών, <br /> 13888 Ιδιώτες,13818
									Επαγγελματίες{" "}
								</h2>{" "}
								<a
									href="/"
									className="cancel">
									Επιστροφή &gt;
								</a>
							</div>
						</div>
					),
			});
		}
	},
};

export default CustomFunctions;
